import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import media from '../../constants/media';
import theme from '../../constants/theme';

const TextLink = styled.a`
	display: inline-flex;
	color: ${theme.colorsV2.grey6};
	font-family: ${theme.fonts.Arimo};
	font-size: 16px;
	line-height: 1.3;
	transition: all 200ms ease;
	text-decoration: none;

	&:last-of-type {
		margin-bottom: 0;
	}

	&:active {
		color: ${theme.colorsV2.lightRed};
	}

	${media.desktopSmall`
    	cursor: pointer;

		&:hover {
			color: ${theme.colorsV2.mainRed};
		}
	`}
`;

type TProps = {
	className?: string;
	href: string;
	role?: string;
	tabIndex?: number;
	target?: string | null;
	title: string;
};

const GrayTextLink = ({ className, href, role, tabIndex, target, title }: TProps) => {
	return (
		<TextLink
			{...(!href.startsWith('http') &&
				(!href.endsWith('pdf') || !href.endsWith('exe') || !href.endsWith('zip')) && { as: Link, to: href })}
			{...((href.startsWith('http') || href.endsWith('pdf') || href.endsWith('exe') || href.endsWith('zip')) && {
				href: href,
				target: target,
			})}
			aria-label={title}
			className={className}
			rel="noreferrer"
			role={role}
			tabIndex={tabIndex}>
			{title}
		</TextLink>
	);
};

export default GrayTextLink;

GrayTextLink.defaultProps = {
	className: '',
	role: 'link',
	tabIndex: 0,
	target: '_self',
};
